import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/compare-zola-alternative";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/compare/zola-alternative")({
  head: SEO["/compare/zola-alternative"],
  component: () => <ContentPage path="/compare/zola-alternative" body={body} />,
});
